import { render } from "./SubmenuLinks.vue?vue&type=template&id=2338eb98"
import script from "./SubmenuLinks.vue?vue&type=script&lang=js"
export * from "./SubmenuLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__